import { ApolloProvider } from '@apollo/client';
import React from 'react';
import { ConfigProvider } from 'antd';
import { NotificationProvider } from './contexts/Notification';
import Component from './Component';
import client from './apollo';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { STRIPE_API_KEY } from './config';
import AuthService from './services/auth';
import ErrorBoundary from './components/ErrorBoundary';
import { antdTheme } from './antd/theme';

const App = () => {
  AuthService.getMe();
  const apolloClient = client();
  const stripePromise = loadStripe(STRIPE_API_KEY);

  return (
    <ErrorBoundary scope="platform-frontend-app">
      <Elements stripe={stripePromise}>
        <ApolloProvider client={apolloClient}>
          <ConfigProvider theme={antdTheme}>
            <NotificationProvider>
              <Component />
            </NotificationProvider>
          </ConfigProvider>
        </ApolloProvider>
      </Elements>
    </ErrorBoundary>
  );
};
export default App;
